var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('div',[_c('div',{staticClass:"turnpage",attrs:{"id":"turnpage"}},_vm._l((_vm.imagesList),function(item,index){return _c('div',{key:index,style:(` background:url(${item}) no-repeat 100% 100%; background-size:100% 100%;height:100px;`)},[_c('div',{staticClass:"pagenum"},[_vm._v("第"+_vm._s(index+1)+"页")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }